// Shared global CSS for commission-form Selects: arrow on the left, text flush right, no empty gap.
// index.scss is a CSS module (classes get hashed), so these rules are injected as a raw <style> tag.
// rendered as a duplicate <style> in 4 components; selectors are global so dupes are inert.
// Hoist to one global mount only if it ever flickers or the count grows.
export const COMMISSION_SELECT_STYLES = `
    .commission-select .ant-select-arrow {
        right: auto;
        left: 8px;
    }
    .commission-select .ant-select-selection--single .ant-select-selection__rendered {
        margin-right: 10px;
        margin-left: 0px;
        display: flex;
        justify-content: start;
    }
    .commission-select .ant-select-selection-selected-value {
        direction: rtl;
        padding-right: 0px;
    }
    .commission-dropdown .ant-select-dropdown-menu {
        padding-right: 0px;
        direction: rtl;
        text-align: right;
    }
    .commission-dropdown .ant-select-dropdown-menu-item {
        padding-right: 10px;
    }
`
